import { render, staticRenderFns } from "./CitiesForm.vue?vue&type=template&id=529f4fd1&scoped=true"
import script from "./CitiesForm.vue?vue&type=script&lang=js"
export * from "./CitiesForm.vue?vue&type=script&lang=js"
import style0 from "./CitiesForm.vue?vue&type=style&index=0&id=529f4fd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f4fd1",
  null
  
)

export default component.exports